import React from 'react';

type AppProps = {
  value: number;
  testId?: string | null;
};

const Quantity: React.FC<AppProps> = ({ value, testId = null }) => {
  return (
    <p className="text-sm font-medium" data-testid={testId}>
      {value ? `${value} pcs` : '-'}
    </p>
  );
};

export default Quantity;
